/**
 * Unsubscribed Confirmation Page (#797)
 *
 * Shown after user clicks one-click unsubscribe link.
 * Nightfall themed with hero placeholder and CTA to manage preferences.
 */

import { useNavigate } from 'react-router-dom';
import { CheckCircle, Settings } from 'lucide-react';
import Button from '../components/Button';

export default function UnsubscribedPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-oro-bg">
      {/* Hero image placeholder - for future running photo */}
      <div className="w-full h-48 bg-oro-surface border-b border-oro-border flex items-center justify-center">
        <div className="text-center">
          <p className="text-2xl font-bold text-accent tracking-wider mb-1">ORO move™</p>
          <p className="text-text-muted text-sm">The app for communities that move together</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-md mx-auto px-4 py-12 text-center">
        {/* Success icon */}
        <div className="bg-oro-success-soft border border-oro-success/30 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-8 h-8 text-oro-success" />
        </div>

        {/* Message */}
        <h1 className="text-2xl font-bold text-text-primary mb-3">
          You've been unsubscribed
        </h1>
        <p className="text-text-secondary mb-8">
          You will no longer receive email notifications from ORO move.
        </p>

        {/* Info card */}
        <div className="bg-oro-surface border border-oro-border rounded-xl p-4 mb-8 text-left">
          <h3 className="font-medium text-text-primary mb-2">Changed your mind?</h3>
          <p className="text-sm text-text-muted">
            You can re-enable specific notifications anytime from your account settings.
          </p>
        </div>

        {/* CTA */}
        <Button
          onClick={() => navigate('/settings/notifications')}
          variant="secondary"
          size="lg"
          className="w-full"
        >
          <Settings className="w-5 h-5 mr-2" />
          Manage notification preferences
        </Button>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-oro-border">
          <p className="text-xs text-text-muted">
            ORO move — The app for communities that move together
          </p>
        </div>
      </div>
    </div>
  );
}
